// extracted by mini-css-extract-plugin
module.exports = {"viewModals":"reviewLicenses_viewModals__3slsU","table":"reviewLicenses_table__2Oole","container":"reviewLicenses_container__3AOqG","readOnly":"reviewLicenses_readOnly__3Ahus"};